module.exports = __webpack_public_path__ + "static/animation-walk-mask-3c116b3cba85b75c52c23e9ec12e3d1a.png";